<template>
  <div
    class="app-copy-input"
    @click.capture="scheduleReset"
  >
    <AmInput
      :key="nonce"
      v-bind="$attrs"
      inputCopy
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { AmInput } from '@appmax_npm/ds-appmax-v3'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  resetDelay: {
    type: Number,
    default: 1000
  }
})

const nonce = ref(0)
let resetTimer
function scheduleReset() {
  clearTimeout(resetTimer)
  resetTimer = setTimeout(() => { nonce.value += 1 }, props.resetDelay)
}
</script>

<style scoped>
.app-copy-input {
  display: contents;
}
</style>
